import { createSlice } from "@reduxjs/toolkit";
import { ApplicationRootState } from "types";
import { ContactUsState } from "types/contact";

import { extraReducers } from "./contact.extraReducers";

const initialState: ContactUsState = {
  URLWhatsApp: "",
};

const contactUs = createSlice({
  name: "contactUs",
  initialState,
  reducers: {},
  extraReducers: extraReducers,
});

export const selectURLWhatsApp = (state: ApplicationRootState) =>
  state.contactUs.URLWhatsApp;

export default contactUs.reducer;
